import React from "react"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

export default ({ pageContext, location }) => {
  return (
    <>
      <SEO location={location} title="Page1" image="p1.jpg" description="this is page1" />
      <Layout pageContext={pageContext}>
        <h1>Page1</h1>
        <Image name="p1.jpg" />
      </Layout>
    </>
  );
};
